<template>
  <el-popover
    placement="right"
    trigger="hover"
    id="user-menu-box"
    v-model="showUserMenu"
  >
    <div style="width: 200px">
      <div class="popover-menu">
        <span style="font-weight: bold; font-size: 18px; color: #333">{{
          CurrentRealName
        }}</span>
      </div>
      <!-- <div>当前在：{{ currentTenantName }}</div> -->
      <hr style="margin-top: 10px; margin-bottom: 10px" />
      <div class="popover-menu">
        <!--              <el-popover-->
        <!--                v-if="GetCurrentTenantList&&GetCurrentTenantList.length>1"-->
        <!--               style="position: static;left:0;top:0;"-->
        <!--                placement="right"-->
        <!--                width="260"-->
        <!--                v-model="showTenantMenu"-->
        <!--                trigger="hover">-->
        <!--                <div class="tenant-box-title">请选择要切换的系统：</div>-->
        <!--                <div class="tenant-item-box">-->
        <!--                  <div @click="onSelectTenant(item)" :title="item.TenantName" v-for="(item,index) in GetCurrentTenantList" :key="index" class="tenant-box-item btn btn-default">-->
        <!--                    <div class="tenant-item-name">{{item.TenantName}}</div>-->
        <!--                    <span v-if="defaultTenantId===item.TenantId" class="tenant-item-default">当前默认</span>-->
        <!--                    <span @click.stop="setDefaultTenant(item)" v-if="defaultTenantId!==item.TenantId" class="tenant-item-setdefault">设为默认</span>-->
        <!--                  </div>-->
        <!--                </div>-->
        <!--                <div slot="reference" style="margin-bottom: 10px;" class="btn btn-primary-outline">切换系统</div>-->
        <!--              </el-popover>-->
        <div
          v-if="showUserCenterLink"
          @click.stop="toUserMenu"
          class="btn btn-primary-outline"
        >
          委托设置
        </div>
        <!-- <el-button style="width:100%"  @click.stop="toUserMenu"  >委托设置</el-button> -->
      </div>
      <div class="popover-menu">
        <el-button
          type="danger"
          style="width: 100%; background: #f56c6c; color: #fff; border: none"
          @click.stop="onLogout"
          >注销登录
        </el-button>
      </div>
      <div class="popover-menu">
        <el-button
          type="danger"
          style="width: 100%; background: #004a86; color: #fff; border: none"
          @click.stop="updatePaw"
          >更改密码
        </el-button>
      </div>
    </div>
    <div class="menu-user" slot="reference" :title="CurrentRealName">
      <!-- <img :src="HeadPicSrc" :onerror="DefaultImageSrc" /> -->
      <img v-src="HeadPicSrc" :default-src="DefaulHeadPicSrc" />
      <!-- @click="toUserMenu" -->
    </div>
    <el-dialog
      title="更改密码"
      :visible.sync="dialogVisible"
      width="30%"
      :close-on-press-escape="true"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <el-form ref="formData" :rules="formData" :model="dataForm">
        <el-form-item label="原密码" prop="OldPassword">
          <el-input
            show-password
            placeholder="请输入原密码"
            v-model="dataForm.OldPassword"
            clearable
            maxlength="100"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="Password">
          <el-input
            show-password
            placeholder="请输入新密码"
            v-model="dataForm.Password"
            clearable
            maxlength="100"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="PwdCheck">
          <el-input
            show-password
            placeholder="请输入确认密码"
            v-model="dataForm.PwdCheck"
            clearable
            maxlength="100"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <div style="float: right">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="update">确 定</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-popover>
</template>
<script>
import { loginout, selectTenant, setDefaultTenant } from "@/api/authorize.js";
import { updatapaw } from "@/modules/sys/api/employee.js";
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "menu-user",
  props: {
    showUserCenterLink: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const pwdCheckValidate = (rule, value, callback) => {
      if (this.dataForm.Password !== '' && value === '') {
        callback(new Error('确认密码不能为空'))
      } else if (this.dataForm.Password !== value) {
        callback(new Error('新密码和确认密码应相同'))
      } else {
        callback()
      }
    }
    return {
      dataForm: {
        Id: '',
        OldPassword: '',
        Password: '',
        PwdCheck: ''
      },
      showUserMenu: false,
      showTenantMenu: false,
      DefaulHeadPicSrc: "images/header-demo.jpg",
      defaultTenantId: "",
      currentTenantName: "无",
      currentTenantId: "",
      popperOptions: {
        boundariesElement: document.getElementById("user-menu-box"),
      },
      dialogVisible: false,
      formData: {
        OldPassword: [
          {
            required: true,
            message: "原密码不能空",
            trigger: "blur",
          }
        ],
        Password: [
          {
            required: true,
            message: "密码不能空",
            trigger: "blur",
          },
          {
            pattern:
              /^.*(?=.{8,16})(?=.*\d)(?=.*[A-Z]{2,})(?=.*[a-z]{2,})(?=.*[!@#$%^&*?\(\)]).*$/,
            message: "密码格式不正确，包含2位大写字母，2位小写字母，1位数字，1位特殊符号，长度8到16位",
            trigger: "blur",
          },
        ],
        PwdCheck: [
          {required: true, validator: pwdCheckValidate, trigger: 'blur'}
        ]
      },
      useData: {
        id: "",
        paw: "",
      },
    };
  },
  mounted() {
    this.refreshTenantName();
    this.defaultTenantId = this.GetDefaultTenant;
  },
  computed: {
    ...mapGetters([
      "GetCurrentUserInfo",
      "GetCurrentTenantList",
      "GetDefaultTenant",
    ]),
    HeadPicSrc() {
      let src = this.DefaulHeadPicSrc;
      let currentUserInfo = this.GetCurrentUserInfo;
      if (currentUserInfo && currentUserInfo.HeadPicture) {
        src = currentUserInfo.HeadPicture;
      }
      return src;
    },
    CurrentUserId() {
      return this.GetCurrentUserInfo ? this.GetCurrentUserInfo.Id : "";
    },
    CurrentRealName() {
      let currentUserInfo = this.GetCurrentUserInfo;
      let r = "点击登录";
      if (currentUserInfo) {
        r = currentUserInfo.RealName;
      }
      return r;
    },
  },
  methods: {
    refreshTenantName() {
      let str = localStorage.getItem("CurrentTenantInfo");
      if (str) {
        let info = JSON.parse(str);
        if (info) this.currentTenantName = info.TenantName;
        this.currentTenantId = info.TenantId;
      }
    },
    ...mapMutations({
      setCurrentMenus: "UPDATE_CURRENT_MENUS",
      setCurrentConfig: "UPDATE_CURRENT_CONFIG",
      setCurrentUserinfo: "UPDATE_CURRENT_USERINFO",
      setCurrentPermissions: "UPDATE_CURRENT_PERMISSIONS",
      setUsertoken: "UPDATE_USERTOKEN",
      setCurrrentTenants: "UPDATE_CURRENT_TENANT_LIST",
      setRedirectUrl: "UPDATE_REDIRECT_URL",
      setDefaultTenantId: "UPDATE_DEFAULT_TENANT",
    }),
    onLogout() {
      this.showUserMenu = false;
      this.$confirm("即将注销登录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.setUsertoken("");
          this.setRedirectUrl("");
          this.$router.push("/login2");
          loginout().then(() => {});
        })
        .catch(() => {});
      return false;
    },

    updatePaw() {
      this.dialogVisible = true;
    },
    ///更改密码
    update() {
      let self = this;
      self.$refs.formData.validate((valid) => {
        if (valid) {
          this.$confirm("即将更改密码, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            self.dataForm.Id = self.GetCurrentUserInfo.Id;
            updatapaw(this.dataForm).then((res) => {
              if(res.data.Code === 0) {
                self.setUsertoken("");
                self.setRedirectUrl("");
                self.$router.push("/login2");
                loginout()
              }else {
                this.$message.error(res.data.Message)
              }
            });
          });
        }
      });
    },
    setDefaultTenant(item) {
      setDefaultTenant(item.TenantId).then((x) => {
        if (x.data.Code === 0) {
          this.defaultTenantId = item.TenantId;
          this.setDefaultTenantId(item.TenantId);
        }
      });
    },
    onSelectTenant(tenantInfo) {
      //if(this.currentTenantId===tenantInfo.TenantId)return
      this.setCurrentPermissions(tenantInfo.OperationPermissions);
      this.setUsertoken(tenantInfo.Token);
      this._setTenantInfo(tenantInfo);
      this.showTenantMenu = false;
      selectTenant(tenantInfo.TenantId).then(() => {
        this.refreshTenantName();
        this.$message.success("切换成功");
        this.$router.push("/ts/task/list");
      });
    },
    _setTenantInfo(info) {
      localStorage.setItem("CurrentTenantInfo", JSON.stringify(info));
    },
    toUserMenu() {
      this.showUserMenu = false;
      this.$router.push("/usercenter");
      return false;
    },
  },
};
</script>
<style scoped>
.popover-menu {
  width: 100%;
  color: #606266;
  font-size: 14px;
  padding: 5px 0;
}

.popover-menu button {
  height: 40px;
}

.popover-menu div {
  width: 100%;
  height: 40px;
  line-height: 26px;
}

.popover-menu div:hover {
  background-color: #004a86;
  color: #fff !important;
}

.tenant-box-title {
  border-left: 5px solid #004a86;
  padding-left: 5px;
  margin-bottom: 10px;
  margin: 15px 0;
}

.tenant-item-box {
  max-height: 300px;
  overflow-y: auto;
  padding-right: 10px;
}

.tenant-box-item {
  width: 100%;
  text-align: left;
  margin-bottom: 10px;
  position: relative;
  left: 0;
}

.tenant-item-name {
  text-overflow: ellipsis;
  max-width: 160px;
  display: inline-block;
  overflow: hidden;
  vertical-align: middle;
}

.tenant-item-default {
  color: #f56c6c;
  font-size: 12px;
  position: absolute;
  right: 8px;
  top: 10px;
}

.tenant-item-setdefault {
  display: none;
  color: #004a86;
  font-size: 12px;
  position: absolute;
  right: 8px;
  top: 10px;
}

.tenant-box-item:hover .tenant-item-setdefault {
  display: inline-block;
}

.el-dialog__wrapper >>> .el-dialog .el-dialog__header .el-dialog__title {
  line-height: 0;
  font-size: 14px;
}
</style>
